import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-cellular-billing-threshold-dialog',
  styleUrls: ['../billing-dialog.scss'],
  template: `
    <h2 mat-dialog-title>Save and export report</h2>
    <mat-dialog-content>
      <p>Choose the minimum verified usage to include in this billing version.</p>
      <mat-form-field appearance="outline" class="threshold-field">
        <mat-label>4GLTE minimum verified usage</mat-label>
        <input matInput type="number" min="0" max="100000" step="0.1"
               [(ngModel)]="thresholdGb" aria-label="Minimum usage in gigabytes">
        <span matSuffix>GB</span>
        <mat-hint>Rows below this value will not be stored or exported.</mat-hint>
      </mat-form-field>
      <div class="threshold-summary" aria-live="polite">
        <strong>{{ eligibleCount | number }}</strong> of {{ data.usages.length | number }} rows will be included.
      </div>
      <ng-container *ngIf="data.overlayUsages">
        <mat-form-field appearance="outline" class="threshold-field">
          <mat-label>Overlay minimum usage</mat-label>
          <input matInput type="number" min="0" max="100000" step="0.1" [(ngModel)]="overlayThresholdGb" aria-label="Overlay minimum usage in gigabytes">
          <span matSuffix>GB</span>
          <mat-hint>License Overlay usage; only records above 14 GB are eligible.</mat-hint>
        </mat-form-field>
        <div class="threshold-summary" aria-live="polite">{{ overlayEligibleCount | number }} Overlay rows will be saved and exported.</div>
      </ng-container>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="dialogRef.close()">Cancel</button>
      <button mat-raised-button color="primary" type="button"
              [disabled]="!isValid" (click)="dialogRef.close({ thresholdGb: Number(thresholdGb), overlayThresholdGb: Number(overlayThresholdGb) })">
        Save and export
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    p { color: #5f6d79; margin: 0 0 20px; }
    .threshold-field { width: 100%; }
    .threshold-summary { margin-top: 12px; padding: 12px; border-left: 3px solid #2f718f; background: #f3f7f9; color: #4e5d69; }
    .threshold-summary strong { color: #20384d; }
  `]
})
export class CellularBillingThresholdDialogComponent {
  thresholdGb = 1;
  overlayThresholdGb = 14;
  readonly Number = Number;

  constructor(
    public dialogRef: MatDialogRef<CellularBillingThresholdDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { defaultThreshold: number, usages: number[], overlayUsages?: number[] }
  ) {
    this.thresholdGb = data.defaultThreshold;
  }

  get isValid(): boolean {
    const value = Number(this.thresholdGb);
    return this.thresholdGb !== null && Number.isFinite(value) && value >= 0 && value <= 100000 &&
      (!this.data.overlayUsages || (this.overlayThresholdGb !== null && Number.isFinite(Number(this.overlayThresholdGb)) && Number(this.overlayThresholdGb) >= 0 && Number(this.overlayThresholdGb) <= 100000));
  }
  get overlayEligibleCount(): number {
    return this.isValid ? (this.data.overlayUsages || []).filter(value => value > 14 && value >= Number(this.overlayThresholdGb)).length : 0;
  }

  get eligibleCount(): number {
    const threshold = Number(this.thresholdGb);
    return this.isValid ? this.data.usages.filter(value => value >= threshold).length : 0;
  }
}
